// libs
import React, { memo } from 'react';

import { CarouselDotsProps } from './types';
import Video from './Video';
import Dot from './Dot';
//constants
const ACTIVE_FILL_OPACITY = '1';
const DROPPED_FILL_OPACITY = '0.16';

function CarouselDots({ isVideo, isActive, className, size }: CarouselDotsProps) {
  const fillOpacity = isActive ? ACTIVE_FILL_OPACITY : DROPPED_FILL_OPACITY;
  if (isVideo) return <Video size={size + 1} className={className} fillOpacity={fillOpacity} />;
  return <Dot size={size} className={className} fillOpacity={fillOpacity} />;
}

export default memo(CarouselDots);
